export default function ReportAndAnalytics() {
  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title" id="page-title">
              Reports &amp; Analytics
            </div>
            <div className="page-sub" id="page-sub">
              Platform-wide analytics
            </div>
          </div>
          <div className="topbar-right" id="topbar-right" />
        </div>
        <div className="content" id="content-area">
          <div className="stat-grid">
            <div className="stat-card">
              <div className="stat-icon">👥</div>
              <div className="stat-label">Total Users</div>
              <div className="stat-value">128</div>
              <div className="stat-delta delta-up">All time</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">💰</div>
              <div className="stat-label">Total Revenue</div>
              <div className="stat-value">₹14.2L</div>
              <div className="stat-delta delta-up">All time</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">🏢</div>
              <div className="stat-label">Properties</div>
              <div className="stat-value">48</div>
              <div className="stat-delta delta-up">Platform-wide</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">🏠</div>
              <div className="stat-label">Rooms Managed</div>
              <div className="stat-value">2,840</div>
              <div className="stat-delta delta-up">All owners</div>
            </div>
          </div>
          <div className="two-col">
            <div className="card">
              <div className="card-title">Monthly Revenue</div>
              <div style={{ marginBottom: 10 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 12,
                    marginBottom: 3,
                  }}
                >
                  <span>Jan 2025</span>
                  <span style={{ fontWeight: 600 }}>₹0.9L</span>
                </div>
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{ width: "60%", background: "#378ADD" }}
                  />
                </div>
              </div>
              <div style={{ marginBottom: 10 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 12,
                    marginBottom: 3,
                  }}
                >
                  <span>Feb 2025</span>
                  <span style={{ fontWeight: 600 }}>₹1.0L</span>
                </div>
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{ width: "67%", background: "#378ADD" }}
                  />
                </div>
              </div>
              <div style={{ marginBottom: 10 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 12,
                    marginBottom: 3,
                  }}
                >
                  <span>Mar 2025</span>
                  <span style={{ fontWeight: 600 }}>₹1.3L</span>
                </div>
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{ width: "87%", background: "#378ADD" }}
                  />
                </div>
              </div>
              <div style={{ marginBottom: 10 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 12,
                    marginBottom: 3,
                  }}
                >
                  <span>Apr 2025</span>
                  <span style={{ fontWeight: 600 }}>₹1.4L</span>
                </div>
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{ width: "93%", background: "#378ADD" }}
                  />
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-title">User Growth</div>
              <div style={{ marginBottom: 10 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 12,
                    marginBottom: 3,
                  }}
                >
                  <span>Jan 2025</span>
                  <span style={{ fontWeight: 600 }}>98</span>
                </div>
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{ width: "76%", background: "#639922" }}
                  />
                </div>
              </div>
              <div style={{ marginBottom: 10 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 12,
                    marginBottom: 3,
                  }}
                >
                  <span>Feb 2025</span>
                  <span style={{ fontWeight: 600 }}>108</span>
                </div>
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{ width: "84%", background: "#639922" }}
                  />
                </div>
              </div>
              <div style={{ marginBottom: 10 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 12,
                    marginBottom: 3,
                  }}
                >
                  <span>Mar 2025</span>
                  <span style={{ fontWeight: 600 }}>119</span>
                </div>
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{ width: "93%", background: "#639922" }}
                  />
                </div>
              </div>
              <div style={{ marginBottom: 10 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 12,
                    marginBottom: 3,
                  }}
                >
                  <span>Apr 2025</span>
                  <span style={{ fontWeight: 600 }}>128</span>
                </div>
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{ width: "100%", background: "#639922" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
